import api from '../services/config/api';

export const deleteClient = (clientId: number) => api.delete(`/client/${clientId}`);
